export const getNewElements = (newArray: any[], oldArray: any[], key = 'parameterId') => {
  return newArray.filter(item => !oldArray.some(oldItem => oldItem[key] == item[key]));
};

export const scrollToTop = (topRef: React.RefObject<HTMLDivElement | null>) => {
  if (!topRef.current) return;
  topRef.current.scrollIntoView({ behavior: 'smooth' });
};

export const formatNumber = (value: any) => {
  if (value === 0) return '0';
  return parseFloat(value).toFixed(2);
};

export function checkQualityForNewAnnotation(annotations: any[], newStartDate: any, newEndDate: any) {
    const newStart = new Date(newStartDate);
    const newEnd = new Date(newEndDate);

    let qualities: any = [];
    let exceedMaxLimits = true;
    let exceedMinLimits = true;

    for (const annotation of annotations) {
      const startDate = new Date(annotation.startDate);
      const endDate = new Date(annotation.endDate);

      if (newStart <= endDate && newEnd >= startDate) {
        qualities.push(annotation.quality);

        if (newStart >= startDate) {
          exceedMinLimits = false;
        }
        if (newEnd <= endDate) {
          exceedMaxLimits = false;
        }
      }
    }

    if (qualities.length > 0 && (exceedMaxLimits || exceedMinLimits)) {
      const minQuality = Math.min(...qualities);
      return `${minQuality} - 10`;
    }

    if (qualities.length === 0) {
      return '10';
    } else if (qualities.length === 1) {
      return `${qualities[0]}`;
    } else {
      const minQuality = Math.min(...qualities);
      const maxQuality = Math.max(...qualities);
      return `${minQuality} - ${maxQuality}`;
    }
  }